// extracted by mini-css-extract-plugin
module.exports = {"input":"events_input__PPYny","error":"events_error__Ht0ES","infoPlate":"events_infoPlate__IWb8A","shake":"events_shake__Dc1cx"};